import { window, document } from "browser-monads"
import React, { useEffect, useCallback } from "react"
import { connect } from "react-redux"
import { Script } from "gatsby"
import { requestAppleLogin } from "../state/modules/login"
import styled from "styled-components"
import useTimeout from "use-timeout"
import { TxlGhostButton } from "./TxlButton"
import { useTranslation } from "react-i18next"

const AppleWidgetContainer = styled.div`
  height: 36px;
  margin-left: 9px;
`

const TxlGhostButtonWithCustomPadding = styled(TxlGhostButton)`
  padding: 2px 0;
`

const AppleSignInButton = ({ className, login }) => {
  const { t } = useTranslation("generic")

  // We need to wrap this in a small delay to ensure the script from the render body is executed first
  useTimeout(() => {
    if (window.AppleID) {
      window.AppleID.auth.init({
        clientId: "com.transferxl.www2",
        scope: "email name",
        redirectURI: "https://www.transferxl.com/.netlify/functions/appleauth",
        state: "my-amazing-state",
        nonce: "my-amazing-nonce",
        usePopup: true,
      })
    }
  }, 100)

  const handleLogin = useCallback(
    data => {
      login(data)
    },
    [login]
  )

  useEffect(() => {
    document.addEventListener("AppleIDSignInOnSuccess", handleLogin)

    return () => {
      document.removeEventListener("AppleIDSignInOnSuccess", handleLogin)
    }
  }, [handleLogin])

  const appleSignInUrl = `https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/${t(
    "##.Auth.AppleSignInLocale"
  )}/appleid.auth.js`

  return (
    <>
      <Script src={appleSignInUrl} />
      <TxlGhostButtonWithCustomPadding $primaryColor="black" display="block">
        <AppleWidgetContainer
          className={className}
          id="appleid-signin"
          data-color="white"
          data-type="continue"
          data-border="false"
          data-border-radius="50"
        />
      </TxlGhostButtonWithCustomPadding>
    </>
  )
}

const mapDispatchToProps = dispatch => {
  return {
    login: data => dispatch(requestAppleLogin(data)),
  }
}

export default connect(null, mapDispatchToProps)(AppleSignInButton)
